import {useEffect, useState} from "react";
import {useFormContext} from "react-hook-form";
import {css} from "@panda/css";

import {InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {EmailInputWithVerification, EmailVerificationResponse} from "@pg-rp/email-with-verification";

import {SmsLoginAccountMismatchMessage} from "../../../auth/components/auth_card/SmsLoginAccountMismatchMessage";
import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";

interface Props {
    verificationData: EmailVerificationResponse | undefined;
    verificationTrigger: (email: string | null) => void;
    disablePhone?: boolean;
    smsLoginErrorMessage?: string | null;
}

export const LeadFormUserDataFields = (props: Props) => {
    const {verificationTrigger, verificationData, disablePhone, smsLoginErrorMessage} = props;
    const codes = useAppSelector((state) => state.variables.data?.country_codes);
    const {data: userProfile} = useGetUserProfileQuery();
    const {watch, getValues} = useFormContext();
    const [isSmsLoginErrorHidden, setIsSmsLoginErrorHidden] = useState(false);
    const shouldShowSmsLoginError = Boolean(smsLoginErrorMessage && !isSmsLoginErrorHidden);

    useEffect(() => {
        setIsSmsLoginErrorHidden(false);
    }, [smsLoginErrorMessage]);

    useEffect(() => {
        if (!smsLoginErrorMessage) {
            return undefined;
        }

        // Snapshot the email/phone present when the error appeared so we only hide it on a real user edit.
        // watch() also fires on programmatic same-value writes (the email verification hook calls
        // setValue("email", ...) on a debounce), which would otherwise hide the error without any user action.
        const {email: emailAtError, phone: phoneAtError} = getValues();
        const phoneAtErrorKey = JSON.stringify(phoneAtError);

        const subscription = watch((values, {name}) => {
            if (name !== "email" && name !== "phone" && !name?.startsWith("phone.")) {
                return;
            }

            const emailEdited = values.email !== emailAtError;
            const phoneEdited = JSON.stringify(values.phone) !== phoneAtErrorKey;

            if (emailEdited || phoneEdited) {
                setIsSmsLoginErrorHidden(true);
            }
        });

        return () => subscription.unsubscribe();
    }, [smsLoginErrorMessage, watch, getValues]);

    return (
        <div className={userDataWrapper}>
            <InputField name="name" placeholder="Imię i nazwisko" dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_NAME_INPUT} />
            <EmailInputWithVerification
                verificationData={verificationData}
                verificationTrigger={verificationTrigger}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_EMAIL_INPUT}
            />
            <PhoneFieldControlled
                name="phone"
                codes={codes ?? []}
                placeholder="Numer telefonu"
                maxMenuHeight={200}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_PHONE_INPUT}
                disabled={disablePhone ?? !!userProfile?.phone}
                fieldState={shouldShowSmsLoginError ? "error" : undefined}
                afterInput={shouldShowSmsLoginError && smsLoginErrorMessage ? <SmsLoginAccountMismatchMessage message={smsLoginErrorMessage} /> : undefined}
            />
        </div>
    );
};

const userDataWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 3
});
import {useEffect, useState} from "react";
import {useFormContext} from "react-hook-form";
import {css} from "@panda/css";

import {InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {EmailInputWithVerification, EmailVerificationResponse} from "@pg-rp/email-with-verification";

import {SmsLoginAccountMismatchMessage} from "../../../auth/components/auth_card/SmsLoginAccountMismatchMessage";
import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";

interface Props {
    verificationData: EmailVerificationResponse | undefined;
    verificationTrigger: (email: string | null) => void;
    disablePhone?: boolean;
    smsLoginErrorMessage?: string | null;
}

export const LeadFormUserDataFields = (props: Props) => {
    const {verificationTrigger, verificationData, disablePhone, smsLoginErrorMessage} = props;
    const codes = useAppSelector((state) => state.variables.data?.country_codes);
    const {data: userProfile} = useGetUserProfileQuery();
    const {watch, getValues} = useFormContext();
    const [isSmsLoginErrorHidden, setIsSmsLoginErrorHidden] = useState(false);
    const shouldShowSmsLoginError = Boolean(smsLoginErrorMessage && !isSmsLoginErrorHidden);

    useEffect(() => {
        setIsSmsLoginErrorHidden(false);
    }, [smsLoginErrorMessage]);

    useEffect(() => {
        if (!smsLoginErrorMessage) {
            return undefined;
        }

        // Snapshot the email/phone present when the error appeared so we only hide it on a real user edit.
        // watch() also fires on programmatic same-value writes (the email verification hook calls
        // setValue("email", ...) on a debounce), which would otherwise hide the error without any user action.
        const {email: emailAtError, phone: phoneAtError} = getValues();
        const phoneAtErrorKey = JSON.stringify(phoneAtError);

        const subscription = watch((values, {name}) => {
            if (name !== "email" && name !== "phone" && !name?.startsWith("phone.")) {
                return;
            }

            const emailEdited = values.email !== emailAtError;
            const phoneEdited = JSON.stringify(values.phone) !== phoneAtErrorKey;

            if (emailEdited || phoneEdited) {
                setIsSmsLoginErrorHidden(true);
            }
        });

        return () => subscription.unsubscribe();
    }, [smsLoginErrorMessage, watch, getValues]);

    return (
        <div className={userDataWrapper}>
            <InputField name="name" placeholder="Imię i nazwisko" dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_NAME_INPUT} />
            <EmailInputWithVerification
                verificationData={verificationData}
                verificationTrigger={verificationTrigger}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_EMAIL_INPUT}
            />
            <PhoneFieldControlled
                name="phone"
                codes={codes ?? []}
                placeholder="Numer telefonu"
                maxMenuHeight={200}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_PHONE_INPUT}
                disabled={disablePhone ?? !!userProfile?.phone}
                fieldState={shouldShowSmsLoginError ? "error" : undefined}
                afterInput={shouldShowSmsLoginError && smsLoginErrorMessage ? <SmsLoginAccountMismatchMessage message={smsLoginErrorMessage} /> : undefined}
            />
        </div>
    );
};

const userDataWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 3
});
